(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ks-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ks-club-search')) {
    customElements.define('ks-club-search', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.input = this.querySelector('input');
        this.panel = this.querySelector('.ks-clubhouse__results');
        this.options = Array.from(this.querySelectorAll('[role="option"]'));
        this.status = this.querySelector('[role="status"]');
        this.empty = this.querySelector('.ks-clubhouse__empty');
        this.list = this.querySelector('[role="listbox"]');
        this.loading = this.querySelector('.ks-clubhouse__loading');
        this.error = this.querySelector('.ks-clubhouse__error');
        this.matches = [];
        this.input.addEventListener('input', () => this.show());
        this.input.addEventListener('focus', () => this.show());
        this.input.addEventListener('click', () => { if (this.panel.hidden) this.show(); });
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') { event.preventDefault(); this.close(); event.stopPropagation(); }
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            if (this.panel.hidden) this.show();
            if (!this.matches.length) return;
            this.active = this.active < 0 ? (event.key === 'ArrowDown' ? 0 : this.matches.length - 1) : (this.active + (event.key === 'ArrowDown' ? 1 : -1) + this.matches.length) % this.matches.length;
            this.select();
          }
          if (event.key === 'Enter') {
            event.preventDefault();
            if (!this.panel.hidden && this.matches.length) this.matches[this.active < 0 ? 0 : this.active].querySelector('a').click();
          }
        });
        this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.close(); });
        this.addEventListener('click', (event) => { if (event.target.closest('a')) this.close(); });
        this.closest('header').querySelector('details').addEventListener('toggle', (event) => { if (event.target.open) this.close(); });
      }
      async loadClubs() {
        if (this.directoryLoaded) return;
        if (this.directoryRequest) return this.directoryRequest;
        this.loading.hidden = false;
        this.list.setAttribute('aria-busy', 'true');
        this.status.textContent = this.loading.textContent;
        this.error.hidden = true;
        this.directoryRequest = (async () => {
          let source = document;
          if (!source.querySelector('[data-ks-club-directory]')) {
            const response = await fetch(this.dataset.directoryUrl, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
            if (!response.ok) throw new Error('Club directory unavailable');
            source = new DOMParser().parseFromString(await response.text(), 'text/html');
          }
          if (!source.querySelector('[data-ks-club-directory]')) throw new Error('Club directory unavailable');
          const seen = new Set();
          const options = [];
          source.querySelectorAll('[data-ks-club-directory] [data-ks-club-url]').forEach((club) => {
            const url = new URL(club.dataset.ksClubUrl, document.baseURI);
            if (url.origin !== new URL(document.baseURI).origin || seen.has(url.pathname)) return;
            seen.add(url.pathname);
            const option = document.createElement('li');
            option.id = this.list.id + '-' + options.length;
            option.setAttribute('role', 'option');
            option.setAttribute('aria-selected', 'false');
            const link = document.createElement('a');
            link.href = url.href;
            link.tabIndex = -1;
            if (club.dataset.ksClubLogo) {
              const image = document.createElement('img');
              image.src = club.dataset.ksClubLogo;
              image.alt = '';
              image.width = 44;
              image.height = 44;
              image.className = 'ks-clubhouse__club-logo';
              link.append(image);
            }
            const title = document.createElement('span');
            title.textContent = club.dataset.ksClubTitle;
            link.append(title);
            option.append(link);
            options.push(option);
          });
          this.list.replaceChildren(...options);
          this.options = options;
          this.directoryLoaded = true;
        })().catch(() => {
          this.error.hidden = false;
          this.status.textContent = this.error.textContent;
        }).finally(() => {
          this.loading.hidden = true;
          this.list.removeAttribute('aria-busy');
          this.directoryRequest = null;
          if (this.wantsOpen) this.filterClubs();
        });
        return this.directoryRequest;
      }
      show() {
        this.wantsOpen = true;
        this.panel.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        this.filterClubs();
        this.loadClubs();
      }
      filterClubs() {
        const query = this.input.value.trim().toLocaleLowerCase();
        this.matches = this.options.filter((option) => {
          const match = option.textContent.toLocaleLowerCase().includes(query);
          option.hidden = !match;
          option.setAttribute('aria-selected', 'false');
          option.querySelector('a').tabIndex = match ? 0 : -1;
          return match;
        });
        this.active = -1;
        this.input.removeAttribute('aria-activedescendant');
        this.empty.hidden = !this.directoryLoaded || this.matches.length > 0;
        this.status.textContent = this.directoryLoaded ? this.status.dataset.count.replace('[count]', this.matches.length) : (this.error.hidden ? this.loading.textContent : this.error.textContent);
      }
      select() {
        this.options.forEach((option) => option.setAttribute('aria-selected', 'false'));
        const option = this.matches[this.active];
        option.setAttribute('aria-selected', 'true');
        this.input.setAttribute('aria-activedescendant', option.id);
        option.scrollIntoView({ block: 'nearest' });
      }
      close() {
        this.wantsOpen = false;
        this.panel.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.status.textContent = '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
